import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import StreamForm from "../../../components/data_products/streams/StreamForm";
import { useGetDataVendorStreamAnalyticsQuery, useGetDataVendorStreamQuery } from '../../../api/dataVendorStreamApiSlice';
import StreamAnalytics from '../../../components/data_products/streams/StreamAnalytics';
import {useAdminBucket} from "../../../components/utils";
import {useControlledTabs} from "../../../components/Tabs";


export default function DataVendorStream(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { dataVendorKey, streamId } = useParams();
  const { data: stream, isSuccess } = useGetDataVendorStreamQuery([dataVendorKey, streamId])
  const bucket = useAdminBucket(dataVendorKey)
  const [tabProps,] = useControlledTabs("stream", props)

  const handleBack = () => history.push({
    pathname: `/data_vendors/${dataVendorKey}`,
    state: {activeTab: 'streams'}
  });

  const {
    data: stats,
    isSuccess: isStatsSuccess,
    isError: isStatsError,
    refetch: refetchStats
  } = useGetDataVendorStreamAnalyticsQuery(
    [dataVendorKey, streamId],
    {
      refetchOnMountOrArgChange: true
    })

  if ( !isSuccess ) return (<></>)
  return (
    <>
      <Title main={t("menu.streams")} sub={stream.name} onBack={handleBack}>
        <FormButton edit state={{activeTab: tabProps.active}}/>
      </Title>
      <StreamForm
        bucket={bucket}
        stream={stream}
        disabled
        tabProps={tabProps}
        extraTabs={[
        <StreamAnalytics
          as="analytics"
          icon="chart"
          stream={stream}
          stats={stats}
          isSuccess={isStatsSuccess}
          isError={isStatsError}
          retry={refetchStats}
        />
      ]}/>
    </>
  )
}




